import { API } from 'aws-amplify'

/**
 * Asks the backend whether this device's clock is close enough to server time to use the app.
 *
 * Fails open, and must never throw. Callers await this inside created()/mounted() hooks
 * (Login.vue, DefaultLayout.vue); a rejection here aborts the rest of the hook, which in
 * DefaultLayout would skip subscription setup, LogRocket init and the resize listeners.
 *
 * @param {Date} browserTime - This device's current time.
 * @returns {Promise<boolean>} false only when the backend positively reports the clock is skewed.
 */
export const checkClockSync = async (browserTime) => {
    let isTimeSynchronized = true
    try {
        const apiName = 'heraPublicApi';
        const path = '/time-sync-check';
        const post = {
        body: { browserTime }
        }
        const { response } = await API.post(apiName, path, post);
        isTimeSynchronized = response
    } catch (error) {
        // A check we could not complete says nothing about the user's clock, so assume it is fine.
        console.error('Clock sync check failed; assuming the clock is in sync.', error)
    }
    return isTimeSynchronized
}
